import { Form } from "react-bootstrap";

export default function InputField({fieldInfo, handleInputValues, inputValues}) {
    if (fieldInfo.type === 'select') {
        return (
            <Form.Control
                key={fieldInfo.key}
                as= {fieldInfo.type}
                aria-label= {fieldInfo.label}
                onChange={(e) => {handleInputValues(fieldInfo.key, e.target.value)}}
                value={inputValues[fieldInfo.key.toLowerCase()]}
                className='map-input-field'
            >
            <option value={""}>{fieldInfo.label}</option>
            {
            fieldInfo.data.map((data, index) => (
                <option key={index} value={data?.value || data}>{data?.value || data}</option>
              ))
            }
          </Form.Control>
        );
    }

    if (fieldInfo.type === 'text') {
        return (
            <Form.Control
                key={fieldInfo.key}
                type={fieldInfo.type}
                aria-label= {fieldInfo.label}
                onChange={(e) => {handleInputValues(fieldInfo.key, e.target.value)}}
                value={inputValues[fieldInfo.key.toLowerCase()]}
                className='map-input-field'
                placeholder={fieldInfo.label}
                maxLength={6}
            >
            </Form.Control>
        );
    }
}